import { Component, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { OutboundDialerService } from '../../services/outbound-dialer.service';
import { LEADSOURCE } from '@app/constants';
@Component({
  selector: 'app-lead-preview-modal',
  templateUrl: './lead-preview-modal.component.html',
  styleUrls: ['./lead-preview-modal.component.scss'],
})
export class LeadPreviewModalComponent implements OnInit, OnDestroy {
  IsModalOpen = this.dialerService.isModalOpen$;
  dialEnabled = this.dialerService.isDialEnabled$;
  leadModel = this.dialerService.leadModel$;
  direction = this.dialerService.direction$;
  count = this.dialerService.count$;

  @ViewChild('Hubspot') hubspotTemplate!: TemplateRef<any>;
  @ViewChild('Ziply') ziplyTemplate!: TemplateRef<any>;
  @ViewChild('TikTok') tiktokTemplate!: TemplateRef<any>;
  @ViewChild('Empty') emptyTemplate!: TemplateRef<any>;
  ngOnDestroy(): void { }
  ngOnInit(): void { }
  constructor(public dialerService: OutboundDialerService) { }
  get currentTemplate(): TemplateRef<any> {
    switch (this.dialerService.template$.getValue()) {
      case LEADSOURCE.HUBSPOT:
        return this.hubspotTemplate;
      case LEADSOURCE.ZIPLY:
        return this.ziplyTemplate;
      case LEADSOURCE.TIKTOK:
        return this.tiktokTemplate;
      default:
        return this.emptyTemplate;
    }
  }
  dialCall() {
    this.dialerService.setDialEnabled(false);
    this.dialerService.dialCall();
  }
}
